import { createAsyncThunk } from "@reduxjs/toolkit";
import { ACTION_PAYOUT_ACCOUNT } from "../../action-types/actions";
import { APP_PATH } from "../../api/backendPath";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { getLocalizedErrorMessage } from "../../utils/messageHelper";
import i18n from "../../i18n";

// API: GET /api/v1/payment/settlements/dashboard?provider_type=imaging&order_type=normal|insured
// Returns the provider's financial summary (net balance) for the given order type.
export const fetchProviderDashboardReducer = createAsyncThunk(
  ACTION_PAYOUT_ACCOUNT.fetch_provider_dashboard,
  async (
    { provider_type = "imaging", order_type = "normal" } = {},
    { rejectWithValue },
  ) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const queryParams = new URLSearchParams({
        provider_type,
        order_type,
      }).toString();

      const response = await axiosPrivate.get(
        `${process.env.REACT_APP_API_URL}${APP_PATH.getSettlementDashboard}?${queryParams}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        return { order_type, summary: response.data.data };
      }
      return rejectWithValue(getLocalizedErrorMessage({ response }, i18n));
    } catch (error) {
      console.error("Error fetching provider dashboard:", error);
      return rejectWithValue(getLocalizedErrorMessage(error, i18n));
    }
  },
);
